import { LocalPlayerTrophy } from './top10/LocalPlayerTrophy';

export const HeaderUserName = ({ user }) => {
  const name = typeof user?.name === 'string' ? user.name.trim().replace(/\s+/g, ' ') : '';
  const displayName = name || 'Golfer';
  const [firstName, ...remainingNames] = displayName.split(' ');

  return (
    <div className="ps-shell-brand flex items-center min-w-0 w-44 max-w-full h-8">
      <span
        className="block min-w-0 truncate font-black tracking-tight text-lg uppercase"
        title={displayName}
        data-testid="header-user-name"
      >
        <span className="text-[var(--ps-primary)]">{firstName}</span>
        {remainingNames.length > 0 && <>{' '}<span className="text-[var(--ps-gold)]">{remainingNames.join(' ')}</span></>}
      </span>
      <LocalPlayerTrophy userId={user?.user_id} testId="header-local-player-trophy" />
    </div>
  );
};